import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "./Reveal";
import { CHAPTERS } from "./data";
import { useContent } from "./content";

export const Manifesto = () => {
  const c = useContent();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "12%"]);

  return (
    <section id="approach" data-testid="manifesto-section" className="py-24 md:py-32 bg-muted/60 relative grain">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          {/* Sticky left rail */}
          <div className="lg:col-span-5">
            <div className="lg:sticky lg:top-28">
              <Reveal>
                <span className="uppercase tracking-[0.24em] text-xs font-bold text-accent">
                  {c.approach_eyebrow}
                </span>
                <h2 className="mt-4 font-display font-medium tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[1.02]">
                  {c.approach_title}
                </h2>
                <p className="mt-6 text-foreground/65 max-w-md leading-relaxed">
                  {c.approach_subtitle}
                </p>
              </Reveal>

              <Reveal delay={0.15}>
                <div className="mt-10 relative clip-frame-b overflow-hidden shadow-xl">
                  <motion.img
                    style={{ y }}
                    src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000"
                    alt="Peoplelab collaboration"
                    className="w-full h-80 object-cover scale-110"
                  />
                </div>
              </Reveal>
            </div>
          </div>

          {/* Chapters */}
          <div className="lg:col-span-7 flex flex-col gap-6">
            {CHAPTERS.map((c, i) => (
              <Reveal key={c.no} delay={i * 0.05}>
                <div
                  data-testid={`chapter-${c.no}`}
                  className="bg-card border border-border rounded-3xl p-8 md:p-10 hover:border-primary/30 transition-colors duration-500"
                >
                  <div className="flex items-baseline gap-5">
                    <span className="font-heading text-5xl md:text-6xl font-bold text-secondary/40 leading-none">
                      {c.no}
                    </span>
                    <div>
                      <h3 className="font-heading text-2xl md:text-3xl font-medium tracking-tight">
                        {c.title}
                      </h3>
                      <p className="mt-3 text-foreground/70 leading-relaxed max-w-lg">{c.body}</p>
                    </div>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
